var map = {
	"./IMG_2674.jpg": 7990,
	"./IMG_2683.jpg": 2252,
	"./IMG_2698.jpg": 9284,
	"./IMG_2699.jpg": 1089,
	"./IMG_2702.jpg": 6092,
	"./IMG_2710.jpg": 5845,
	"./IMG_2711.jpg": 1528,
	"./IMG_2712.jpg": 1511,
	"./IMG_2724.jpg": 4144,
	"./IMG_92711.jpg": 8274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5960;